module.exports = __webpack_public_path__ + "img/yilianGl1.71bf283c.png";